namespace GeniuzPOS.InitialData {
    export interface PsDiscCouponTypeShopForm {
        DiscCouponType: Serenity.StringEditor;
        ShopId: Serenity.StringEditor;
    }

    export class PsDiscCouponTypeShopForm extends Serenity.PrefixedContext {
        static formKey = 'InitialData.PsDiscCouponTypeShop';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsDiscCouponTypeShopForm.init)  {
                PsDiscCouponTypeShopForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(PsDiscCouponTypeShopForm, [
                    'DiscCouponType', w0,
                    'ShopId', w0
                ]);
            }
        }
    }
}
